import { env } from '@/shared/config';
import { getAccessToken } from './auth.store';
import { refreshSession } from './session-refresher';

/**
 * 인증 REST 호출 — tRPC 에 없는 관리자 REST(차단 · 해제)용.
 *
 * 401 이면 세션을 한 번 재발급받아 재시도한다 — tRPC 자동 재발급 링크와
 * 같은 재발급기(단일 비행)를 공유하므로 동시 재발급 경쟁이 없다.
 */
export const authedFetch = async (path: string, init?: RequestInit): Promise<Response> => {
  const attempt = (): Promise<Response> => {
    const token = getAccessToken();

    return fetch(`${env.VITE_API_URL}${path}`, {
      ...init,
      headers: {
        ...init?.headers,
        ...(token ? { authorization: `Bearer ${token}` } : {}),
      },
    });
  };

  const response = await attempt();

  if (response.status !== 401) {
    return response;
  }

  return (await refreshSession()) ? attempt() : response;
};
